import SignIn from "./SignIn";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import OtpVerification from "./OtpVerification";
import "./AuthResponsive.scss";

const AuthRoutes = [
  {
    path: "/",
    modules: ["auth"],
    auth: false,
    strict: false,
    component: SignIn,
  },
  {
    path: "/sign-in",
    modules: ["auth"],
    auth: false,
    strict: true,
    component: SignIn,
  },
  {
    path: "/otp-verification",
    modules: ["auth"],
    auth: false,
    strict: false,
    component: OtpVerification,
  },
  {
    path: "/forgot-password",
    modules: ["auth"],
    auth: false,
    strict: false,
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    modules: ["auth"],
    auth: false,
    strict: false,
    component: ResetPassword,
  },
];

export default AuthRoutes;
